import React from "react";
import BaseApi from '../api/BaseApi.js';

export default class MobileUploadScreen extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uploading: false,
            success: false,
            uploadedCount: 0,
            error: null,
            eventName: null
        };

        this.fileInputRef = React.createRef();

        this.openFileDialog = this.openFileDialog.bind(this);
        this.handleFileInput = this.handleFileInput.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
    }

    componentDidMount() {
        // опционально можно загрузить инфу о событии
        // BaseApi.get("/event/photos/mobile-upload-info", {
        //     params: { token: this.props.token }
        // })
    }

    openFileDialog() {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    }

    handleFileInput(event) {
        this.handleFiles(event.target.files);
        event.target.value = "";
    }

    async resizeJpegFile(file, maxSide = 1800, quality = 0.82) {
        const imageUrl = URL.createObjectURL(file);

        try {
            const img = await new Promise((resolve, reject) => {
                const image = new Image();
                image.onload = () => resolve(image);
                image.onerror = reject;
                image.src = imageUrl;
            });

            const scale = Math.min(
                maxSide / img.width,
                maxSide / img.height,
                1
            );

            const width = Math.round(img.width * scale);
            const height = Math.round(img.height * scale);

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            const blob = await new Promise((resolve, reject) => {
                canvas.toBlob(
                    result => result
                        ? resolve(result)
                        : reject(new Error("Ошибка сжатия")),
                    "image/jpeg",
                    quality
                );
            });

            return new File(
                [blob],
                file.name.replace(/\.[^.]+$/, ".jpg"),
                { type: "image/jpeg" }
            );
        } finally {
            URL.revokeObjectURL(imageUrl);
        }
    }

    async handleFiles(fileList) {
        const files = Array.from(fileList || []);

        if (files.length === 0) {
            return;
        }

        const jpegFiles = files.filter(file =>
            file.type === "image/jpeg" || file.type === "image/jpg"
        );

        if (jpegFiles.length === 0) {
            this.setState({
                error: "Можно загружать только JPEG-фотографии"
            });
            return;
        }

        this.setState({
            uploading: true,
            error: null,
            success: false
        });

        try {
            const resizedFiles = [];

            for (const file of jpegFiles) {
                const resized = await this.resizeJpegFile(file);
                resizedFiles.push(resized);
            }

            const formData = new FormData();
            formData.append("token", this.props.token);

            resizedFiles.forEach(file => {
                formData.append("files[]", file);
            });

            const response = await BaseApi.post(
                "/event/photos/mobile-upload",
                formData,
                {
                    withCredentials: false
                }
            );

            const uploadedCount =
                response &&
                response.data &&
                response.data.result &&
                response.data.result.length
                    ? response.data.result.length
                    : resizedFiles.length;

            this.setState({
                uploading: false,
                success: true,
                uploadedCount
            });

        } catch (error) {
            console.log(error);

            this.setState({
                uploading: false,
                error: "Не удалось загрузить фотографии"
            });
        }
    }

    render() {
        return (
            <div
                className="container"
                style={{
                    maxWidth: "500px",
                    paddingTop: "40px"
                }}
            >
                <div className="card shadow-sm">
                    <div className="card-body text-center">

                        <h4 className="mb-3">
                            Загрузка фото
                        </h4>

                        <p className="text-muted">
                            Выберите фотографии с телефона
                        </p>

                        <input
                            ref={this.fileInputRef}
                            type="file"
                            accept="image/jpeg"
                            multiple
                            className="d-none"
                            onChange={this.handleFileInput}
                        />

                        <button
                            className="btn btn-primary btn-lg w-100"
                            onClick={this.openFileDialog}
                            disabled={this.state.uploading}
                        >
                            Выбрать фото
                        </button>

                        {this.state.uploading && (
                            <div className="mt-3 text-muted">
                                Загрузка...
                            </div>
                        )}

                        {this.state.success && (
                            <div className="alert alert-success mt-3">
                                Загружено фото: {this.state.uploadedCount}
                                <br/>
                                Можно закрыть страницу
                            </div>
                        )}

                        {this.state.error && (
                            <div className="alert alert-danger mt-3">
                                {this.state.error}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
} 



// WEBPACK FOOTER //
// ./src/ui/mobile-upload.js